import { render, staticRenderFns } from "./InputFileButton.vue?vue&type=template&id=0ec4630a&scoped=true"
import script from "./InputFileButton.vue?vue&type=script&lang=js"
export * from "./InputFileButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec4630a",
  null
  
)

export default component.exports